import React from "react";
import { useTranslation } from "../../i18n/useTranslation";
import { Typography, Table } from "antd";

const { Text } = Typography;

export const DETAIL_BY_NAME = {
  "Jetson-01": {
    fullDeviceId: "8a7b6c98761d2e3f",
    hardwareFingerprint: "CPU: x86_64 AMD Ryzen 7 5800X | GPU: NVIDIA GeForce RTX 3080 | MAC: 00:1A:2B:3C:4D:5E",
    systemInfo: "Linux (Ubuntu 22.04) | Kernel: 5.15.0-88-generic",
    licenseValidTime: "2026-01-16 09:20 (GMT+8)",
    logData: [
      { key: "1", time: "2026-01-16 09:18:32", type: "inference", result: "success" },
      { key: "2", time: "2026-01-16 09:15:01", type: "heartbeat", result: "success" },
      { key: "3", time: "2026-01-16 09:10:22", type: "inference", result: "success" },
      { key: "4", time: "2026-01-16 09:05:11", type: "heartbeat", result: "success" },
      { key: "5", time: "2026-01-16 09:00:00", type: "inference", result: "success" },
    ],
  },
  "PC-Workstation": {
    fullDeviceId: "9d8e7f65432c3b4a",
    hardwareFingerprint: "CPU: x86_64 Intel Core i7-12700 | GPU: NVIDIA GeForce RTX 3070 | MAC: 00:1B:2C:3D:4E:5F",
    systemInfo: "Windows 11 (22H2) | Build 22621",
    licenseValidTime: "2026-01-16 09:20 (GMT+8)",
    logData: [
      { key: "1", time: "2026-01-15 18:28:00", type: "heartbeat", result: "success" },
      { key: "2", time: "2026-01-15 18:25:00", type: "inference", result: "success" },
    ],
  },
  "Test-Device-03": {
    fullDeviceId: "7c6d5e43213b4a59",
    hardwareFingerprint: "CPU: ARM64 | GPU: N/A | MAC: 00:1C:2D:3E:4F:60",
    systemInfo: "Linux (Debian 11) | Kernel: 5.10.0",
    licenseValidTime: "-",
    logData: [],
  },
};

const DeviceDetailContent = ({ device }) => {
  const { t } = useTranslation();
  const detail = DETAIL_BY_NAME[device.deviceName] || DETAIL_BY_NAME["Jetson-01"];
  const logColumns = [
    { title: t("logTime"), dataIndex: "time", key: "time" },
    { title: t("logType"), dataIndex: "type", key: "type" },
    { title: t("logResult"), dataIndex: "result", key: "result" },
  ];

  return (
    <div className="space-y-4 max-h-[70vh] overflow-y-auto pr-1">
      <div>
        <h2 className="text-lg font-semibold text-[#004b67]">
          {t("deviceDetailPageTitle", { name: device.deviceName })}
        </h2>
        <div className="mt-2 h-px bg-[#e6f7ff]" />
      </div>

      <div className="bg-gray-50 rounded-lg border border-gray-100 p-4">
        <h3 className="text-sm font-medium text-gray-500 mb-3">{t("boundLicenseInfo")}</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div className="flex justify-between items-center">
            <Text type="secondary">{t("licenseId")}</Text>
            <Text strong>LIC2025060100001</Text>
          </div>
          <div className="flex justify-between items-center">
            <Text type="secondary">{t("licenseValidTime")}</Text>
            <Text>{detail.licenseValidTime}</Text>
          </div>
          <div className="flex justify-between items-center">
            <Text type="secondary">{t("deviceStatus")}</Text>
            <span className={`inline-block px-2 py-0.5 rounded text-xs ${
              device.statusKey === "Active" ? "bg-green-50 text-green-700" :
              device.statusKey === "Inactive" ? "bg-gray-100 text-gray-600" : "bg-red-50 text-red-600"
            }`}>
              {t(`status${device.statusKey}`)}
            </span>
          </div>
        </div>
      </div>

      <div className="bg-gray-50 rounded-lg border border-gray-100 p-4">
        <h3 className="text-sm font-medium text-gray-500 mb-3">{t("deviceFingerprint")}</h3>
        <div className="space-y-3">
          <div className="flex justify-between items-start gap-4">
            <Text type="secondary" className="flex-shrink-0">{t("deviceId")}</Text>
            <Text className="break-all text-sm">{detail.fullDeviceId}</Text>
          </div>
          <div className="flex justify-between items-start gap-4">
            <Text type="secondary" className="flex-shrink-0">{t("hardwareFingerprint")}</Text>
            <Text className="break-all text-sm">{detail.hardwareFingerprint}</Text>
          </div>
          <div className="flex justify-between items-start gap-4">
            <Text type="secondary" className="flex-shrink-0">{t("systemInfo")}</Text>
            <Text className="break-all text-sm">{detail.systemInfo}</Text>
          </div>
        </div>
      </div>

      <div className="bg-gray-50 rounded-lg border border-gray-100 p-4">
        <h3 className="text-sm font-medium text-gray-500 mb-3">{t("last20Logs")}</h3>
        {detail.logData?.length > 0 ? (
          <Table
            dataSource={detail.logData}
            columns={logColumns}
            pagination={false}
            size="small"
          />
        ) : (
          <Text type="secondary">{t("accountComingSoon")}</Text>
        )}
      </div>

      <div className="bg-gray-50 rounded-lg border border-gray-100 p-4">
        <h3 className="text-sm font-medium text-gray-500 mb-2">{t("rebindRuleTitle")}</h3>
        <ul className="space-y-1.5 text-sm text-gray-600 list-none pl-0">
          <li className="flex gap-2">
            <span className="text-gray-400 mt-1.5 w-1.5 h-1.5 rounded-full bg-gray-400 flex-shrink-0" />
            <span>{t("rebindRule1")}</span>
          </li>
          <li className="flex gap-2">
            <span className="text-gray-400 mt-1.5 w-1.5 h-1.5 rounded-full bg-gray-400 flex-shrink-0" />
            <span>{t("rebindRule2")}</span>
          </li>
          <li className="flex gap-2">
            <span className="text-gray-400 mt-1.5 w-1.5 h-1.5 rounded-full bg-gray-400 flex-shrink-0" />
            <span>{t("rebindRule3")}</span>
          </li>
          <li className="flex gap-2">
            <span className="text-gray-400 mt-1.5 w-1.5 h-1.5 rounded-full bg-gray-400 flex-shrink-0" />
            <span>{t("rebindRule4")}</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default DeviceDetailContent;
